import React from 'react';
import { observer } from 'mobx-react';

// Dependencies
import DOMPurify from 'dompurify';

const FeatureNotice = observer(class FeatureNotice extends React.Component {
  constructor() {
    super();
    this.closeDialog = this.closeDialog.bind(this);
  }

  closeDialog(e) {
    const { SessionStore } = this.props.store;

    e.preventDefault();

    // Remove dialog
    SessionStore.closeDialog();
  }

  render() {
    const { SessionStore } = this.props.store;
    const { featureNoticeSetting, featureNoticeToggle, dialogContent } = SessionStore;

    return(
      <div className="dialog dialog--lg">
        <div className="dialog__content">
          <strong className="dialog__msg">{dialogContent.heading}</strong>

          <div
            className="panel__copy"
            dangerouslySetInnerHTML={{__html: DOMPurify.sanitize(dialogContent.body)}}
          ></div>

          {typeof featureNoticeSetting !== 'undefined' &&
            <div>
              <input
                type="checkbox"
                id="feature"
                className="switch-input"
                ref={(input) => this.feature = input}
                value={true}
                defaultChecked={featureNoticeSetting}
                onChange={featureNoticeToggle}
              />

              <label
                className="switch-label"
                htmlFor="feature"
              >
                <span className="meta">{dialogContent.label}</span>
              </label>

              <label
                className="switch-label--alt"
                htmlFor="feature"
              >
                {dialogContent.label}
              </label>
            </div>
          }

          <a
            href="#app"
            className="btn"
            onClick={(e) => this.closeDialog(e)}
          >
            {dialogContent.button}
          </a>
        </div>
      </div>
    );
  }
})

export default FeatureNotice;



// WEBPACK FOOTER //
// ./src/app/components/Common/FeatureNotice.js